<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » アンケート結果ダウンロードファイル（作成・編集）の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>アンケート結果ダウンロードファイル（作成・編集）の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/enquete-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、編集した内容は保存されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> メモ
        </div>
        <div class="manual-explain">
          メモを設定します。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 設問セット
        </div>
        <div class="manual-explain">
          アンケート結果を集計する対象設問セットを設定します。<br>
          ※作成時のみ指定可能<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 作成期間（開始日時）
        </div>
        <div class="manual-explain">
          アンケート結果を集計する期間（開始日時）を設定します。<br>
          ※作成時のみ指定可能<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 作成期間（終了日時）
        </div>
        <div class="manual-explain">
          アンケート結果を集計する期間（終了日時）を設定します。<br>
          ※作成時のみ指定可能<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 作成ボタン
        </div>
        <div class="manual-explain">
          クリックすることでダウンロードファイルの作成を開始します。<br>
          ※ダウンロードファイルの作成には時間がかかる場合があります<br>
          ※編集時はメモ情報が更新されるのみ
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Survey Results Download File (Create/Edit) Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Survey Results Download File (Create/Edit) Description</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_enquete-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button closes the dialog.<br>
          Edited content will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Memo
        </div>
        <div class="manual-explain">
          Set a memo.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Question Set
        </div>
        <div class="manual-explain">
          Set the target question set for aggregating survey results.<br>
          * Can only be specified during creation<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Creation Period (Start Date/Time)
        </div>
        <div class="manual-explain">
          Set the start date/time for the period to aggregate survey results.<br>
          * Can only be specified during creation<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> Creation Period (End Date/Time)
        </div>
        <div class="manual-explain">
          Set the end date/time for the period to aggregate survey results.<br>
          * Can only be specified during creation<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button starts creating the download file.<br>
          * File creation may take some time<br>
          * In edit mode, only memo information is updated
        </div>

      </mat-card-content>
    </mat-card>

  </div>

</div>